import { useMemo } from 'react';
import { DOMAIN } from '../config';
import { useAuthProfileContext } from '../providers/AuthProfileProvider';
import { useCurrentUser } from '../queries/use-current-user';

type ProfileFirm = { id: string; shortId: string };

export function useIsOnboarded(): { isOnboarded: boolean; isLoading: boolean; hasFirm: boolean; hasProfile: boolean } {
    const profile = useAuthProfileContext();
    const userQuery = useCurrentUser(profile[`${DOMAIN}/uuid`]);

    const r = useMemo(() => {
        const firms: ProfileFirm[] = profile[`${DOMAIN}/workpapers`].firms || [];
        const user = userQuery.data?.user;
        const hasProfile = Boolean(user);
        const hasFirm = firms.length > 0;
        const isOnboarded = hasProfile && hasFirm;
        const isLoading = userQuery.isLoading;

        return {
            isOnboarded,
            isLoading,
            hasFirm,
            hasProfile,
        };
    }, [profile, userQuery.data?.user, userQuery.isLoading]);

    return r;
}
